export const actionIdMapping: any = {
  staging: {
    End_to_end_sync: 196,
    Fetcher: 190,
    Unifier: 177,
    business_advisor: 229,
  },
  production: {
    End_to_end_sync: 100,
    Fetcher: 97,
    Unifier: 90,
    business_advisor: 126,
  },
};
